var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 68,
    viewBox: "0 0 67 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.6336 60.9227V30.8782H6.36621V60.9227C6.36621 62.2867 6.90805 63.5948 7.87252 64.5593C8.83699 65.5238 10.1451 66.0656 11.5091 66.0656H55.4908C56.8548 66.0656 58.1629 65.5238 59.1273 64.5593C60.0918 63.5948 60.6336 62.2867 60.6336 60.9227Z",
    stroke: "#1377D4",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 66.0605V30.8679",
    stroke: "#1377D4",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0668 22.6446V25.7303C65.0668 27.0943 64.525 28.4024 63.5605 29.3668C62.596 30.3313 61.2879 30.8731 59.924 30.8731H7.07596C5.71199 30.8731 4.40389 30.3313 3.43941 29.3668C2.47494 28.4024 1.93311 27.0943 1.93311 25.7303V22.6446C1.93311 21.2806 2.47494 19.9725 3.43941 19.008C4.40389 18.0435 5.71199 17.5017 7.07596 17.5017H59.924C61.2879 17.5017 62.596 18.0435 63.5605 19.008C64.525 19.9725 65.0668 21.2806 65.0668 22.6446Z",
    stroke: "#1377D4",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 17.5017C33.5 13.0017 28.2543 2.5 20.3754 2.5C7.56457 2.5 12.2291 17.5017 18.3646 17.5017",
    stroke: "#1377D4",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 17.5017C33.5 13.0017 38.7457 2.5 46.6246 2.5C59.4354 2.5 54.7709 17.5017 48.6354 17.5017",
    stroke: "#1377D4",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.1ca5ac6546a9dc72276702a989513fc6.svg";
export { ForwardRef as ReactComponent };